<template>
  <div class="block-common-box">
    <TitleCommon title="Party Information " />
    <div class="block-common-content">
      <div
        class="slide-btn left-btn"
        :class="{
          'swiper-button-disabled': mySwiperNew && mySwiperNew.isBeginning,
        }"
        @click="mySwiperNew.slidePrev()"
      ></div>
      <div class="swiper-content">
        <div class="swiper" id="certify">
            <div class="swiper-container partyswiper" id="certifySwiper">
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="item in menuArr"
                  :key="item.id"
                >
                  <img :src="$imgUrl + item.src" />
                </div>
              </div>
            </div>
          </div>
      </div>
      <div
        class="slide-btn right-btn"
        :class="{ 'swiper-button-disabled': mySwiperNew && mySwiperNew.isEnd }"
        @click="mySwiperNew.slideNext()"
      ></div>
    </div>
  </div>
</template>
  
  <script setup>
import Swiper from "swiper";

import TitleCommon from "./TitleCommon.vue";
import { onMounted, ref } from "vue";

const mySwiperNew = ref(null);

const setSwiper = () => {
  const swiper = new Swiper("#certifySwiper", {
    loop: true, // 是否循环播放
    // autoplay: true, //是否自动播放 true 是  false 否
    slidesPerView: 2, //一排展示几个
    effect: "coverflow", //轮播图的切换效果  coverflow 3D
    centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
    // spaceBetween: "0%", //每个轮播图之间设置距离（单位px）。
    coverflowEffect: {
      rotate: 0, //slide做3d旋转时Y轴的旋转角度
      stretch: 1, //每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
      depth: 50, //slide的位置深度。值越大z轴距离越远，看起来越小。
      modifier: 7, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显
      slideShadows: false, //是否开启slide阴影
    },
    observer: true, //修改swiper自己或子元素时，自动初始化swiper
    observeParents: false, //修改swiper的父元素时，自动初始化swiper
  });
  mySwiperNew.value = swiper;
};
onMounted(() => {
    setSwiper();
})

const menuArr = [
  {
    id: "1",
    src: "/senceA1.png",
  },
  // {
  //   id: "2",
  //   src: "/senceA2.png",
  // },
  {
    id: "3",
    src: "/senceA3.png",
  },
  {
    id: "3",
    src: "/senceA3.png",
  },
];
</script>
  
  <style lang="scss" scoped>
.block-common-content {
  width: 100%;
  height: auto;
  padding-bottom: 115px;
  position: relative;
  .slide-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    width: 60px;
    height: 60px;
    z-index: 2;
    &.left-btn {
      left: 0;
      background: url($imgUrl + "/ic-left.png") no-repeat center / 60px 60px;
    }
    &.right-btn {
      right: 0;
      background: url($imgUrl + "/ic-right.png") no-repeat center / 60px 60px;
    }
  }
  .swiper-content {
    width: 1030px;
    height: 692px;
    margin: 0 auto;
    overflow: hidden;
    .partyswiper  {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
  }
}

#certify {
    position: relative;
    width: 100%;
    height: 692px;
}


#certify  .swiper-slide {
    width: 492px;
    height: 100%;
    position: relative;
    
    &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: rgba(14, 14, 14, 0.5);
        border-radius: 20px;
        z-index: 1;
      }
}
#certify  .swiper-slide.swiper-slide-active {
    &::before {
        content: unset;
    }
}
#certify  .swiper-slide img{
    width: 492px;
    height: 100%;
    display: block;
    margin: 0 auto;
    border-radius: 20px;
}

</style>